module.exports = __webpack_public_path__ + "img/quick-sigorta.6697214e.png";